import { render } from "./Logo.vue?vue&type=template&id=d31cbfc0&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=d31cbfc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31cbfc0"]])

export default __exports__